export default __webpack_public_path__ + "static/media/g15.182cd05a.jpg";